'use client';

import { cn } from '@core/utils';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

export interface ProgressProps extends ComponentPropsWithoutRef<'div'> {
  /** 진행률 (0-100) */
  value?: number;
  /** 최대값 (기본: 100) */
  max?: number;
}

export const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, max = 100, ...props }, ref) => {
    const percentage = Math.min(100, Math.max(0, (value / max) * 100));

    return (
      <div
        ref={ref}
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
        className={cn(
          'h-8 w-full overflow-hidden rounded-pill bg-Gray-200',
          className,
        )}
        {...props}
      >
        <div
          className="h-full bg-B-500 transition-all duration-300 motion-reduce:transition-none"
          style={{ width: `${percentage}%` }}
        />
      </div>
    );
  },
);

Progress.displayName = 'Progress';
